// @flow
import { entityReducer } from "src/utils/reducerUtils";
import SeriesModel from "src/models/SeriesModel";

export const series = entityReducer({
  name: "series",
  Model: SeriesModel
});
